"use client";

import { ComponentProps, PropsWithChildren } from "react";
import { useIsShopsite } from "@context/DomainContext";
import * as SwitchPrimitive from "@radix-ui/react-switch";
import { Switch as RadixSwitch } from "@radix-ui/themes";
import { joinClassNames } from "@utils/helpers";

interface Props {
  shopsiteClasses?: string;
  whitelabelClasses?: string;
  sharedClasses?: string;
}

export default function Switch({
  shopsiteClasses = "",
  whitelabelClasses = "",
  sharedClasses = "",
  size = "2",
  ref,
  ...restProps
}: ComponentProps<typeof RadixSwitch> & PropsWithChildren<Props>) {
  const isShopsite = useIsShopsite();

  if (isShopsite) {
    return (
      <SwitchPrimitive.Root
        className={joinClassNames(
          "shrink-0 w-[42px] h-[25px] bg-gray-300 rounded-full relative shadow focus:ring-2 focus:ring-indigo-500 data-[state=checked]:bg-indigo-400 outline-none cursor-default",
          sharedClasses,
          shopsiteClasses
        )}
        ref={ref}
        {...restProps}
      >
        <SwitchPrimitive.Thumb className="block w-[21px] h-[21px] bg-white rounded-full transition-transform duration-100 translate-x-0.5 will-change-transform data-[state=checked]:translate-x-[19px]" />
      </SwitchPrimitive.Root>
    );
  }

  return (
    <RadixSwitch
      size={size}
      className={joinClassNames(sharedClasses, whitelabelClasses)}
      ref={ref}
      {...restProps}
    />
  );
}
